import React from 'react'
import { graphql } from 'gatsby'
import Header from '../components/header'
import Footer from '../components/footer'
import QuoteForm from '../components/quote_form'
import FormSidebar from '../components/form_sidebar'
import Seo from '../components/seo'

const QuotePage = ({ data }) => {
  const entry = data.markdownRemark

  return (
    <div className="page">
      <Seo title={entry.frontmatter.page_title} description={entry.frontmatter.meta_description} image="" pathname="/quote/" />
      <Header />
      <main className="layout entry grey">
        <div className="entry__container">
          <h1 className="hire_page_title">{entry.frontmatter.heading}</h1>
          <div className="hire_form_layout">
            <div className="hire_form_main">
              <QuoteForm />
            </div>
            <FormSidebar />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default QuotePage

export const query = graphql`
  query QuotePage($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        page_title
        meta_description
        heading
      }
      fields {
        slug
      }
    }
  }
`
